import React from 'react'
import {render} from 'react-dom'
import './shared/assets/styles/global.css'
import App from './App'

render(<App />, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js